import React, { useEffect, useState, useRef } from 'react'
import { useTranslation } from 'react-i18next'
import { Paper } from '@mui/material'
import { Container, Col, Row } from 'react-bootstrap'
import { useOutletContext } from 'react-router-dom'
import moment from 'moment'

import useFetchData from 'Shared/Hooks/useFetchData'
import DataTable from 'Shared/Components/DataTable'
import { apiUrl } from 'Shared/utils'
import useLoop from 'Shared/Hooks/useLoop'
import { IconButtonComponent } from 'Shared/Components/Icon'
import { TbArrowsMaximize, TbArrowsMinimize } from 'react-icons/tb'
import MapDisplay from './components/MapDisplay'
import { MdCenterFocusStrong } from 'react-icons/md'

const ProximityList = () => {
  const { profile, role, setPageLoading } = useOutletContext()

  const { t } = useTranslation()
  const { send } = useFetchData()

  const [cameras, setCameras] = useState([])
  const [minimize, setMinimize] = useState(false)

  const mapRef = useRef(null)
  const tableRef = useRef()

  const loadData = async () => {
    const body = await send({
      method: "GET",
      url: `${apiUrl}/proximity/list`,
      returnType: "json"
    })

    setCameras(body.features.map((i) => ({
      "device_id": i["properties"]["device_id"],
      "name": i["properties"]["name"],
      "plant_type": i["properties"]["plant_type"],
      "last_update": i["properties"]["location"]["last_update"] ? moment(i["properties"]["location"]["last_update"]*1000).format("YYYY-MM-DD HH:mm:ss") : null,
      "online": (
        <div style={{ display: "flex", justifyContent: "center", alignItems: "center", textAlign: "center" }}>
          <span style={{ height: "15px", width: "15px", backgroundColor: i["properties"]["status"] ? "green" : "red", borderRadius: "50%" }}></span>
        </div>
      )
    })))

    mapRef.current.updateData(body)
  }

  const fetchMapExtent = async () => {
    const body = await send({
      method: "GET",
      url: `${apiUrl}/smartwatch/map_extent`,
      returnType: "json"
    })

    if (body != null) {
      mapRef.current.setMapExtent(body)
    }
  }

  const focus = (id, zoom) => {
    const feature = mapRef.current.getFeature(id)

    mapRef.current.zoomToFeature(id, feature, zoom)
  }

  useEffect(() => {
    const init = async () => {
      setPageLoading(true)

      await Promise.all([
        loadData(),
        fetchMapExtent()
      ])

      setPageLoading(false)
    }

    init()
  }, [])

  useLoop(loadData, 10000)
  
  return (<>
    <div className="mainContainer" style={{ backgroundColor: "white", borderRadius: "15px" }}>
      <Container fluid className="mainContainer" style={{ flexGrow: 1 }}>
        <Row style={{ height: minimize ? "100%" : "50%", marginBottom: "5px" }}>
          <Col xs={12} style={{ height: "100%", overflow: "hidden", padding: "5px 10px 5px 10px", display: "flex" }}>
            <div style={{ flex: 1 }}>
              <MapDisplay focus={focus} ref={mapRef}/>
            </div>
          </Col>
        </Row>
  
        {minimize ? (<>
          <Row style={{ marginTop: "5px", display: minimize ? "block" : "none" }}>
            <Col xs={12} style={{ height: "100%", padding: "5px 10px 10px 10px" }}>
              <div style={{ width: "100%", display: "flex", justifyContent: "end", paddingRight: "10px" }}>
                <IconButtonComponent onClick={() => setMinimize(false)}>
                  <TbArrowsMaximize size={20}/>
                </IconButtonComponent>
              </div>
            </Col>
          </Row>
        </>) : (
          <Row style={{ height: "50%", marginTop: "5px", display: minimize ? "none" : "block" }}>
            <Col xs={12} style={{ height: "100%", padding: "5px 10px 10px 10px" }}>
              <Paper elevation={0} sx={{ height: "100%", display: "flex", flexFlow: "column" }}>
                <DataTable
                  data={cameras} count={null}
                  columns={{
                    "online": { "label": t("general_online"), "sorting": false, "nowrap": true },
                    "name": { "label": t("general_deviceName"), "sorting": false, "nowrap": true },
                    "plant_type": { "label": t("proximity_plantType"), "sorting": false, "nowrap": true },
                    "last_update": { "label": t("general_lastUpdate"), "sorting": false, "nowrap": true },
                  }}
                  renderActions={(row) => { return [
                    {icon: <MdCenterFocusStrong size={20}/>, text: "Locate Worker", onClick: function(row) { focus(row["device_id"], true) }},
                  ]}}
                  appActions={() => { return [
                    {icon: <TbArrowsMinimize size={20}/>, text: t("general_minimize"), onClick: function() { setMinimize(true) }}
                  ]}}
                />
              </Paper>
            </Col>
          </Row>
        )}
      </Container> 
    </div>
  </>)
}

export default ProximityList
